import { IFilter } from "../shared/ifilter";
import { ICMenu } from "../entities/icmenu";

export class ICMenuFilter implements IFilter<ICMenu> {
  Count: number;
  CurrentPage: number;
  PerPage: number;
  Sort: number;
  SortType: number;
  UsePagination: boolean;
  SearchQuery: string;

  UserId: number;

  constructor(data?: Partial<ICMenuFilter>) {
    Object.assign(this, data);
  }
}
